import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="image-preview"
export default class extends Controller {
  connect() {
    console.log("imagePreviewController connected");
  }

  preview(event) {
    const file = event.target.files?.[0];
    if (!file) return;

    const image = event.target.closest(".picture").querySelector("img");
    const reader = new FileReader();
    reader.onload = (e) => (image.src = e.target.result);
    reader.readAsDataURL(file);
  }
}
